import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import AccordionColumnBox from "../../../components/AccordionColumnBox";
import Newsletter from "components/Newsletter";

export default function CandidateFAQPage({ global, faqItems }) {
  return (
    <>
      <SeoHead
        page_name={`Candidate FAQs  | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
        canonical_link={`job-seekers/candidate-faqs`}
      />
      <MainBanner
        global={global}
        pathPrefix={`candidate_faqs_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Candidate FAQ</h1>
            <p>
              Are you a candidate and have a question for us? Check below for
              our frequently asked questions for our top candidate enquiries to
              streamline the job application process for all candidates. From
              application updates to locked accounts, you can find your answer
              here.
            </p>
          </>
        }
        displayImage1={false}
        imageURL1={`/site-assets/images/abstract-4.png`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        breadcrumb_title="Candidate FAQs"
        secondary_breadcrumb_url={"/about-us"}
        secondary_breadcrumb_title={"About Us"}
      />
      <AccordionColumnBox
        global={global}
        pathPrefix="candidate_faq_page.faq_section"
        customClass="my-5"
        post={faqItems}
      />
      <Newsletter
        global={global}
        pathPrefix={`job_page.newsletter`}
        customClass={`py-5 grayGradientBg`}
        // content={
        //   <>
        //     <h2>More Informations</h2>
        //   </>
        // }
        content_2={
          <>
            <h2>Subscribe to our newsletter</h2>
            <p>up to date with Lorien</p>
          </>
        }
        formId={`e1da7ff6-feb2-4696-93be-b43ec16b6009`}
        successPageUrl={`/jobs/subscription-success/`}
        // buttonTitle={`Insights`}
        // buttonLink={`/blog/`}
        // buttonTitle2={`Similar Roles`}
        // buttonLink2={`/`}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const faqItem = await Collection("frequently_asked_question");
  const faqItems = faqItem.getItems();

  return {
    props: {
      global,
      faqItems,
    },
  };
}
